export enum Token {
  ACCESS_TOKEN = 'token',
  REFRESH_TOKEN = 'refresh',
  USER = 'user'
}
